/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1PecegepayBilletCoursefinpersonpaymentidPdf200,
  GetApiV1PecegepayBilletCoursefinpersonpaymentidPdf401,
  GetApiV1PecegepayBilletCoursefinpersonpaymentidPdf404,
  GetApiV1PecegepayBilletCoursefinpersonpaymentidPdf500,
  GetApiV1PecegepayBilletCoursefinpersonpaymentidPdfPathParams,
  GetApiV1PecegepayBilletCoursefinpersonpaymentidPdfQueryResponse,
} from "../../types/pecegePayBilletController/GetApiV1PecegepayBilletCoursefinpersonpaymentidPdf.ts";

export const getApiV1PecegepayBilletCoursefinpersonpaymentidPdfPathParamsSchema =
  z.object({
    courseFinPersonPaymentId: z.coerce.number().int(),
  }) as unknown as ToZod<GetApiV1PecegepayBilletCoursefinpersonpaymentidPdfPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1PecegepayBilletCoursefinpersonpaymentidPdf200Schema =
  z.instanceof(
    File,
  ) as unknown as ToZod<GetApiV1PecegepayBilletCoursefinpersonpaymentidPdf200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1PecegepayBilletCoursefinpersonpaymentidPdf401Schema =
  z.any() as unknown as ToZod<GetApiV1PecegepayBilletCoursefinpersonpaymentidPdf401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1PecegepayBilletCoursefinpersonpaymentidPdf404Schema =
  z.any() as unknown as ToZod<GetApiV1PecegepayBilletCoursefinpersonpaymentidPdf404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1PecegepayBilletCoursefinpersonpaymentidPdf500Schema =
  z.any() as unknown as ToZod<GetApiV1PecegepayBilletCoursefinpersonpaymentidPdf500>;

export const getApiV1PecegepayBilletCoursefinpersonpaymentidPdfQueryResponseSchema =
  z.lazy(
    () => getApiV1PecegepayBilletCoursefinpersonpaymentidPdf200Schema,
  ) as unknown as ToZod<GetApiV1PecegepayBilletCoursefinpersonpaymentidPdfQueryResponse>;
